class VariantsMetafield extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const groupId = this.dataset.groupId;
        if (!groupId) {
            this.remove();
            return;
        }

        console.log('Fetching product variants for group ID:', groupId);

        try {
            fetch(`/pages/product-variants`)
                .then(response => response.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');

                    doc.querySelectorAll('.product-variants-card')?.forEach(product => {
                        const productGroupId = product.dataset.groupId;

                        if (groupId != productGroupId) {
                            product.remove();
                        }
                    });

                    this.innerHTML = doc.body.innerHTML;
                })
                .then(() => {
                    const mainProductId = this.dataset.productId;
                    const selectedProduct = this.querySelector(`[data-product-id="${mainProductId}"]`);

                    const swiper = new Swiper(this.querySelector('.swiper'), {
                        slidesPerView: 3.5,
                        spaceBetween: 10,
                        freeMode: true,
                        centeredSlides: true,
                        loop: true,
                        loopedSlides: 25,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren: true,
                    });

                    const selectedIndex = Number(selectedProduct.dataset.swiperSlideIndex);

                    swiper.slideToLoop(selectedIndex, 0, false);
                    swiper.update();
                });
        }
        catch (error) {
            console.error('Error fetching product variants:', error);
            this.remove();
        }
    }
}

if (!customElements.get('variants-metafield')) {
    customElements.define('variants-metafield', VariantsMetafield);
}